import Dashboard from "../../dashboard";

export default function InvestorDashboard() {
  return <Dashboard type="investor" />;
}
